const firebase = require('firebase/app');
require('firebase/auth');

let config = {
	apiKey: "AIzaSyDHpGlS66_5_WEJABHSJF_JRB4qNwJxVzk",
	authDomain: "kure-dev-191711.firebaseapp.com",
	databaseURL: "https://kure-dev-191711.firebaseio.com",
	projectId: "kure-dev-191711",
	storageBucket: "kure-dev-191711.appspot.com",
	messagingSenderId: "880900664877"
};

if (process.env.REACT_APP_DEPLOYMENT_ENV === 'production') {
	config = {
		apiKey: "AIzaSyBgl1E__BPQPLSMk7vlsdROOhf1IiYctSo",
		authDomain: "kure-live.firebaseapp.com",
		databaseURL: "https://kure-live.firebaseio.com",
		projectId: "kure-live",
		storageBucket: "kure-live.appspot.com",
		messagingSenderId: "620592289263",
	};
}

if (!firebase.apps || (firebase.apps && !firebase.apps.length)) {
	firebase.initializeApp(config);
}


export default firebase;
